module.exports = __webpack_public_path__ + "img/gyermektamogatas-2.17966afb.jpg";